export default (intl, options) => options.map(option => ({
  ...option,
  label: intl.formatMessage(option.label, option.label.plural),
}));
